'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {
  CATALOG_URL_PARAMS,
  DEFAULT_CATALOG_SORT,
} from '@/features/products-catalog/search-params'

export const SORT_OPTIONS = [
  { value: 'most_relevant', label: 'Mais relevantes' },
  { value: 'popular', label: 'Populares' },
  { value: 'newest', label: 'Novos' },
] as const

export default function SelectSort() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const params = new URLSearchParams(searchParams.toString())
  // A URL é a única fonte da verdade da ordenação.
  const currentSort =
    params.get(CATALOG_URL_PARAMS.sort) ?? DEFAULT_CATALOG_SORT

  function handleChangeOrder(sort: string) {
    params.set(CATALOG_URL_PARAMS.sort, sort)
    params.delete(CATALOG_URL_PARAMS.page)
    router.push(`?${params.toString()}`, { scroll: false })
  }

  return (
    <Select onValueChange={handleChangeOrder} value={currentSort}>
      <SelectTrigger className="h-12 border-[#D7D7D9] px-5 text-[#656566] text-sm focus:ring-0 focus:ring-offset-0 md:h-7 md:justify-evenly md:rounded-full">
        <SelectValue placeholder={currentSort} />
      </SelectTrigger>
      <SelectContent>
        {SORT_OPTIONS.map(option => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
